import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { fetch } from '@haaretz/s-graphql-fetcher';
export const ArticleLinkDataBsQueryDocument = `
    query ArticleLinkDataBSQuery($model: PageModelInput!, $dateFormat: String, $expand: String) {
  Page(model: $model, dateFormat: $dateFormat, expand: $expand) {
    lineage {
      name: body
      url: href
    }
    seoData {
      canonicalUrl
    }
  }
}
    `;
export const useArticleLinkDataBsQuery = (variables, options)=>useQuery([
        'ArticleLinkDataBSQuery',
        variables
    ], fetch(ArticleLinkDataBsQueryDocument, variables), options);
useArticleLinkDataBsQuery.document = ArticleLinkDataBsQueryDocument;
useArticleLinkDataBsQuery.getKey = (variables)=>[
        'ArticleLinkDataBSQuery',
        variables
    ];
export const useInfiniteArticleLinkDataBsQuery = (pageParamKey, variables, options)=>{
    return useInfiniteQuery([
        'ArticleLinkDataBSQuery.infinite',
        variables
    ], (metaData)=>fetch(ArticleLinkDataBsQueryDocument, {
            ...variables,
            ...metaData.pageParam ?? {}
        })(metaData), options);
};
useInfiniteArticleLinkDataBsQuery.getKey = (variables)=>[
        'ArticleLinkDataBSQuery.infinite',
        variables
    ];
useArticleLinkDataBsQuery.fetcher = (variables, options)=>fetch(ArticleLinkDataBsQueryDocument, variables, options);

//# sourceMappingURL=ArticleLinkDataBS.js.map